<script>
	import CaseInformation from "../CaseForm/CaseInformation/CaseInformation.svelte";
	import InvestigatorInformation from "../CaseForm/InvestigatorInformation/InvestigatorInformation.svelte";
	import VehicleInformationDisplay from "../CaseForm/VehicleInformation/VehicleInformationDisplay.svelte";
	import DriverInformation from "../CaseForm/DriverInformation/DriverInformation.svelte";
	import DamageInformation from "../CaseForm/DamageInformation/DamageInformation.svelte";
	import Quotation from "../CaseForm/Quotation/Quotation.svelte";
	import Others from "../CaseForm/Others/Others.svelte";
	import WorkshopMedia from "../CaseForm/WorkshopMedia/WorkshopMedia.svelte";
	import CompareReports from "src/components/CompareReports/CompareReports.svelte";
	import { isFQCaseOrigin, isOperatorCaseOrigin } from "src/utils/misc";
	export let zendeskTicketId;
	export let linkToCases;
	export let state;
	export let caseDetails;
	export let vehicleDetails;
	export let dateReported;
	export let attribution;
	export let damageCause;
	export let damageCauseType;
	export let staffName;
	export let staffContact;
	export let thirdPartyName;
	export let thirdPartyContact;
	export let incidentDateTime;
	export let form; // caseCreationForm
	export let caseType;
	export let accidentGIAReportNo;
	export let claimType;
	export let selectedSides;
	export let liabilityType;
	export let noOfRepairDays;
	export let actualRepairCost;
	export let remarks;
	export let costBreakdownItems;
	export let workshopInvoiceFiles;
	export let additionalPhotoFiles;
	export let existingAdditionalMedia;
	export let existingWorkshopFiles;
	export let additionalMediaFiles;
	export let vqp;
	export let l1Remarks;
	export let tnsRemarks;
</script>

<div class="tab-content">
	<CaseInformation
		{zendeskTicketId}
		{linkToCases}
		{state}
		{caseDetails}
		{vehicleDetails}
	/>
	<InvestigatorInformation {caseDetails} />
	<VehicleInformationDisplay {caseDetails} {vehicleDetails} />
	<DriverInformation {caseDetails} />
	{#if isOperatorCaseOrigin(caseDetails) || isFQCaseOrigin(caseDetails)}
		<WorkshopMedia {caseDetails} />
	{/if}

	{#if caseDetails.status !== "Quoting"}
		<CompareReports
			caseId={caseDetails.id}
			{state}
			status={caseDetails.status}
		/>
	{/if}
	<DamageInformation
		{caseDetails}
		{state}
		{dateReported}
		{attribution}
		{damageCause}
		{damageCauseType}
		{staffName}
		{staffContact}
		{thirdPartyName}
		{thirdPartyContact}
		{incidentDateTime}
		{vqp}
		{l1Remarks}
	/>
	<Quotation
		{caseDetails}
		{state}
		{form}
		{caseType}
		{accidentGIAReportNo}
		{claimType}
		{selectedSides}
		{liabilityType}
		{noOfRepairDays}
		{actualRepairCost}
		{remarks}
		{costBreakdownItems}
		{incidentDateTime}
		{tnsRemarks}
	/>
	<Others
		{workshopInvoiceFiles}
		{additionalPhotoFiles}
		{state}
		{existingAdditionalMedia}
		{existingWorkshopFiles}
		{caseDetails}
		{additionalMediaFiles}
	/>
</div>
